import script from "./reset-password.vue?vue&type=script&setup=true&lang=js"
export * from "./reset-password.vue?vue&type=script&setup=true&lang=js"

import "./reset-password.vue?vue&type=style&index=0&id=4930bb16&lang=css"

const __exports__ = script;

export default __exports__